import haxell_solution from "../assets/images/haxell_Solutions.svg"
import hol from "../assets/images/HOL.svg"
import lambatoken from "../assets/images/lambatoken.svg"
import uniport_cite from "../assets/images/uniport_cite.svg"

export const clientData = [
    {
        id:1,
        image: haxell_solution
    },
    {
        id:2,
        image: hol
    },
    {
        id:3,
        image: lambatoken
    },
    {
        id:4,
        image: uniport_cite
    },
]